import React from "react";
import "../Contact/Contact.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ContactForm from "../../components/ContactForm/ContactForm";
const Contact = () => {
  return (
    <>
      <Navbar />
      <div id="contact" className="contact-container">
        <div className="contact-left">
          <div className="cont-divs">
            <i className="fa fa-map-marker" aria-hidden="true"></i>
            <span>
              <a
                href="https://maps.app.goo.gl/BkpgcaSKi84uA4NNA"
                target="_blank"
                rel="noreferrer"
              >
                Amir Road, Shad Bagh, Lahore, Pakistan
              </a>
            </span>
          </div>
          <div className="cont-divs">
            <i className="fa fa-envelope" aria-hidden="true"></i>
            <span>
              {" "}
              <a
                href="mailto:shahzaibimran219@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                shahzaibimran219@gmail.com
              </a>
            </span>
          </div>
          <div className="cont-divs">
            <i className="fa fa-whatsapp" aria-hidden="true"></i>
            <span>
              {" "}
              <a
                href="https://wa.me/+923216066007"
                target="_blank"
                rel="noreferrer"
              >
                +92-321-6066007
              </a>
            </span>
          </div>
          <div className="link cont-divs">
            <i className="fa fa-linkedin" aria-hidden="true"></i>
            <a
              href="https://www.linkedin.com/in/shahzaib-imran-2002m/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <span>shahzaib-imran-2002m </span> <br />
              <p>(Click to visit)</p>
            </a>
          </div>
          <div className="link cont-divs">
            <i className="fa fa-github" aria-hidden="true"></i>
            <a
              href="https://github.com/shahzaibimran219"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              <span>shahzaibimran219</span> <br />
              <p>(Click to visit)</p>
            </a>
          </div>
        </div>
        <div className="contact-right">
          <ContactForm/>  
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;
